import type { CategoryFilter } from '@lib/models/category'
import { Filters, PRODUCT_CATEGORY_FILTER_OTHERS } from '@lib/models/internal/filters'
import type { ProductLite } from '@lib/models/product'

const categoriesNamesWithResizing = [
  'McCombos',
  'Signature Collection',
  'Ensaladas',
  'Bebidas',
  'McCafé'
].map((val) => val.toLowerCase())

export const hasCategoryResizingAvailable = (catName: string) => {
  const categoryName = catName.toLowerCase()
  for (const catNameWithResizing of categoriesNamesWithResizing) {
    if (categoryName.includes(catNameWithResizing)) return true
  }
  return false
}

/* Category filters (product.categories) */

// Product without categories belongs to the OTHERS filter, only when the category has filters
const getProductFilterNames = (product: Pick<ProductLite, 'categories'>): string[] =>
  product.categories?.length ? product.categories : [PRODUCT_CATEGORY_FILTER_OTHERS]

// No product with categories => no filters. Otherwise the unique categories (in order of
// appearance) and OTHERS at the end if there is any product without them.
export const buildCategoryFilters = (
  products: Array<Pick<ProductLite, 'categories'>>
): CategoryFilter | undefined => {
  if (!products.some((product) => product.categories?.length)) return undefined

  const names = new Set<string>()
  for (const product of products) {
    for (const name of getProductFilterNames(product)) names.add(name)
  }
  // re-insert OTHERS so it ends up last (a Set keeps insertion order)
  if (names.has(PRODUCT_CATEGORY_FILTER_OTHERS)) {
    names.delete(PRODUCT_CATEGORY_FILTER_OTHERS)
    names.add(PRODUCT_CATEGORY_FILTER_OTHERS)
  }

  // a single filter that every product belongs to filters nothing
  if (names.size === 1) return undefined
  return { [Filters.NAME]: [...names] }
}

export const productHasFilterName = (
  product: Pick<ProductLite, 'categories'>,
  name: string
): boolean => getProductFilterNames(product).includes(name)
